<template>
    <div class="insureBox">
        <avue-crud :data="data"  ref="crud" :option="option" :search.sync="search"  @selection-change="selectionChange" @size-change="sizeChange" :page.sync="page"  @current-change="currentChange" @search-change="searchChange" @search-reset="resetChange">
            <template slot-scope="scope" slot="menuLeft">
                <el-button class="custom" @click="propertyBtn">批量发起签署财产保全申请书</el-button>
                <el-button class="custom" @click="deliveryBtn">批量发起签署送达地址确认书</el-button>
                <el-button class="custom" @click="networkBtn">批量发起签署网络查控申请书</el-button>
                <el-button class="custom" @click="submitBtn">批量提交至保险端</el-button>
            </template>
            <template slot="index" slot-scope="scope">
                {{page.total - ((page.currentPage - 1) * page.pageSize + scope.row.$index)}}
            </template>
            <template slot="menu" slot-scope="scope">
                <el-dropdown>
                    <span class="el-dropdown-link">
                        操作<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item class="pull-down" @click.native="cancelBtn(scope.row)">撤销投保案件</el-dropdown-item>
                        <el-dropdown-item class="pull-down" @click.native="toUploadBtn(scope.row)">上传投保材料</el-dropdown-item>
                        <el-dropdown-item class="pull-down" @click.native="viewBtn(scope.row)">查看留言</el-dropdown-item>
                        <el-dropdown-item class="pull-down" @click.native="resubmitBtn(scope.row)" v-if="scope.row.jd_type_id==3">再次提交投保材料到保险端</el-dropdown-item>
                        <el-dropdown-item class="pull-down" @click.native="verifyBtn(scope.row)">查看待确认保单保函</el-dropdown-item>
                        <el-dropdown-item class="pull-down" @click.native="sealedInsureBtn(scope.row)">上传客户已盖章投保单</el-dropdown-item>
                        <el-dropdown-item class="pull-down" @click.native="viewInsureBtn(scope.row)">查看投保单</el-dropdown-item>
                        <el-dropdown-item class="pull-down" @click.native="viewChargeBtn(scope.row)">查看保险收费信息</el-dropdown-item>
                        <el-dropdown-item class="pull-down" @click.native="paymentBtn(scope.row)">上传缴费信息</el-dropdown-item>
                        <el-dropdown-item class="pull-down" @click.native="allMaterialsBtn(scope.row)">查看全部投保材料和文书</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </template>
            <template slot="jd_type_id", slot-scope="scope">
                <span style="color: #2d8cf0">{{scope.row.jd_type_name}}</span>
            </template>
            <template slot="case_sn" slot-scope="scope" >
                <el-tooltip :content="scope.row.case_sn" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.case_sn }}</p>
                </el-tooltip>
            </template>
            <template slot="zhcai_sn" slot-scope="scope" >
                <el-tooltip :content="scope.row.zhcai_sn" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.zhcai_sn }}</p>
                </el-tooltip>
            </template>
            <template slot="user_name" slot-scope="scope" >
                <el-tooltip :content="scope.row.user_name" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.user_name }}</p>
                </el-tooltip>
            </template>
            <template slot="doc_title" slot-scope="scope" >
                <el-tooltip :content="scope.row.doc_title" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.doc_title }}</p>
                </el-tooltip>
            </template>
            <template slot="contract_sn" slot-scope="scope" >
                <el-tooltip :content="scope.row.contract_sn" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.contract_sn }}</p>
                </el-tooltip>
            </template>
            <template slot="product_name" slot-scope="scope" >
                <el-tooltip :content="scope.row.product_name" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.product_name }}</p>
                </el-tooltip>
            </template>
            <template slot="signers_txt" slot-scope="scope" >
                <el-tooltip :content="scope.row.signers_txt" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.signers_txt }}</p>
                </el-tooltip>
            </template>
        </avue-crud>
    </div>
</template>

<script>
    import {
        cancelInsure,
        check_and_control,
        insureList,
        letter_of_service, resubmitMaterial,
        signFinancialInsurance, submit_to
    } from '../../api/insure';

    export default {
        name: 'insurePage',
        inject:['reload'],
        data() {
            return {
                page:{
                    currentPage: 1,
                    total: 20,  //总数
                    pageSize: 10
                },
                search:{
                    jd_type_id:'',  //投保状态
                    zhcai_sn:'',   //仲裁案号
                    doc_title:'',  //合同名称
                    lawyer_name:'',  //代理人
                    signers_txt:'',  //被申请人
                },
                jd_type_id:'',  //投保状态
                zhcai_sn:'',   //仲裁案号
                doc_title:'',  //合同名称
                lawyer_name:'',  //代理人
                signers_txt:'',  //被申请人
                data: [],
                option:{
                    stripe:true,
                    // index:true,
                    searchMenuSpan:3,
                    indexLabel:'序号',  //添加序号
                    selection: true, //批量选择
                    addBtn:false,  //新增按钮
                    align:'center',  //文本居中
                    menuAlign:'center', //操作栏居中
                    columnBtn:false,  //列动态显隐按钮
                    refreshBtn:false,  //刷新按钮
                    editBtn:false,  //编辑按钮
                    delBtn:false,  //删除按钮
                    menuWidth:150,  //操作栏宽度设置
                    column:[
                        {
                            label: '序号',
                            prop: 'index'
                        },
                        {
                            label:'仲裁案件ID',
                            prop:'id'
                        }, {
                            label:'案件编号',
                            prop:'case_sn'
                        }, {
                            label:'提交人',
                            prop:'tijiao_ren'
                        }, {
                            label:'投保状态',
                            prop:'jd_type_id',
                            searchSpan: 4,
                            search: true,
                            type: "select",
                            dicData:[
                                {
                                    label:'全部',
                                    value:-1
                                },
                                {
                                    label:'待提交投保材料',
                                    value:1
                                },
                                {
                                    label:'待保险公司审核',
                                    value:2
                                },
                                {
                                    label:'保险公司驳回材料',
                                    value:3
                                },
                                {
                                    label:'上传待客户确认保单保函',
                                    value:4
                                },
                                {
                                    label:'待客户确认保单保函',
                                    value:5
                                },
                                {
                                    label:'客户确认保单保函无误',
                                    value:6
                                },
                                {
                                    label:'客户确认保单保函有误',
                                    value:7
                                },
                                {
                                    label:'待客户回传已盖章投保单',
                                    value:8
                                },
                                {
                                    label:'待保险公司上传收款信息',
                                    value:9
                                },
                                {
                                    label:'待客户上传缴费信息',
                                    value:10
                                },
                                {
                                    label:'待保险公司上传正式保单等资料',
                                    value:11
                                },
                                {
                                    label:'投保完成',
                                    value:12
                                },
                            ]
                        }, {
                            label:'仲裁案号',
                            prop:'zhcai_sn',
                            searchSpan: 4,
                            search: true,
                        }, {
                            label:'申请人',
                            prop:'user_name'
                        }, {
                            label:'合同名称',
                            prop:'doc_title',
                            searchSpan: 4,
                            search: true,
                        }, {
                            label:'合同编号',
                            prop:'contract_sn'
                        }, {
                            label:'合同类型',
                            prop:'product_name'
                        }, {
                            label:'代理人',
                            prop:'lawyer_name',
                            searchSpan: 4,
                            search: true,
                        }, {
                            label:'被申请人',
                            prop:'signers_txt',
                            searchSpan: 4,
                            search: true,
                        },
                    ]
                },
            };
        },
        methods:{
            //批量操作
            selectionChange(list){
                this.ids = []
                list.forEach(res=>{
                    this.ids.push(res.id)
                })
            },
            //切换每一页的数量
            sizeChange(val){
                this.page.pageSize=val
                insureList(val,1).then(res=>{
                    if (res.code==200){
                        this.data=res.data.list
                        this.page.total=res.data.count
                        this.page.currentPage=1
                    }
                })
            },
            //分页
            currentChange(num){
                //没有搜索条件 分页
                if ( this.jd_type_id==''&& this.zhcai_sn=='' && this.doc_title=='' && this.lawyer_name=='' && this.signers_txt==''){
                    insureList(10,num).then(res=>{
                        if (res.code==200){
                            sessionStorage.setItem('insurePage', num)
                            this.data=res.data.list
                            this.page.total=res.data.count
                        }
                    })
                }else {
                    insureList(10,num,this.jd_type_id,this.zhcai_sn,this.doc_title,this.lawyer_name,this.signers_txt).then(res=>{
                        if (res.code==200){
                            sessionStorage.setItem('insurePageSearch', num)
                            this.data=res.data.list
                            this.page.total=res.data.count
                        }
                    })
                }
            },
            //搜索
            searchChange(params,done){
                this.jd_type_id=params.jd_type_id
                this.zhcai_sn=params.zhcai_sn
                this.doc_title=params.doc_title
                this.lawyer_name=params.lawyer_name
                this.signers_txt=params.signers_txt

                insureList(10,1,params.jd_type_id,params.zhcai_sn,params.doc_title,params.lawyer_name,params.signers_txt).then(res=>{
                    if (res.code==200){
                        sessionStorage.setItem('insurePageSearch', 1)
                        sessionStorage.setItem('insurePageParams', JSON.stringify(params) )
                        this.data=res.data.list
                        this.page.total=res.data.count
                        this.page.currentPage=1
                    }else {
                        this.$message.error(res.msg)
                    }
                })
                done()
            },
            //重置搜索
            resetChange(){
                sessionStorage.removeItem('insurePage')
                sessionStorage.removeItem('insurePageSearch')
                sessionStorage.removeItem('insurePageParams')
                this.jd_type_id=''
                this.zhcai_sn=''
                this.doc_title=''
                this.lawyer_name=''
                this.signers_txt=''
                insureList(10,1).then(res=>{
                    if (res.code==200){
                        this.data=res.data.list
                        this.page.total=res.data.count
                        this.page.currentPage=1
                        this.$message.success('重置成功')
                    }
                })
            },
            //上传保险材料
            toUploadBtn(row){
                this.$router.push({path:'/uploadMaterial',query:{id:row.id}})
            },
            //撤销投保案件
            cancelBtn(row){
                this.$confirm('请确认是否要将该案件从投保案件中撤销 ', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    cancelInsure({case_id:row.id}).then(res=>{
                        if (res.code==200){
                            this.$message.success(res.msg)
                            this.reload()
                        }else {
                            this.$message.error(res.msg)
                        }
                    })
                }).catch(() => {

                });
            },
            //财产保全申请书
            propertyBtn(){
                if (this.ids==undefined||this.ids==''){
                    this.$message.error('请选择案件');
                    return
                }else {
                    this.$confirm('请确认是否批量签署财产保全申请书 ', '提示', {
                        confirmButtonText: '签署',
                        cancelButtonText: '取消',
                        type: 'warning',
                        beforeClose: (action, instance, done) => {
                            if (action === 'confirm') {
                                instance.confirmButtonLoading = true;
                                instance.confirmButtonText = '执行中...';
                                signFinancialInsurance({case_ids:this.ids}).then(res=>{
                                    if (res.code==200){
                                        this.$message.success(res.msg)
                                        instance.confirmButtonLoading = false;
                                        done();
                                    }else {
                                        this.$message.error(res.msg)
                                        instance.confirmButtonLoading = false;
                                        done();
                                    }
                                })


                            }else {
                                done();
                            }
                        }
                    }).then(() => {

                    }).catch(() => {

                    });
                }
            },
            //送达地址确认书
            deliveryBtn(){
                if (this.ids==undefined||this.ids==''){
                    this.$message.error('请选择案件');
                    return
                }else {
                    this.$confirm('请确认是否批量签署送达地址确认书 ', '提示', {
                        confirmButtonText: '签署',
                        cancelButtonText: '取消',
                        type: 'warning',
                        beforeClose: (action, instance, done) => {
                            if (action === 'confirm') {
                                instance.confirmButtonLoading = true;
                                instance.confirmButtonText = '执行中...';
                                letter_of_service({case_ids:this.ids}).then(res=>{
                                    if (res.code==200){
                                        this.$message.success(res.msg)
                                        instance.confirmButtonLoading = false;
                                        done();
                                    }else {
                                        this.$message.error(res.msg)
                                        instance.confirmButtonLoading = false;
                                        done();
                                    }
                                })


                            }else {
                                done();
                            }
                        }
                    }).then(() => {

                    }).catch(() => {

                    });
                }
            },
            //网络查控申请书
            networkBtn(){
                if (this.ids==undefined||this.ids==''){
                    this.$message.error('请选择案件');
                    return
                }else {
                    this.$confirm('请确认是否批量签署网络查控申请书 ', '提示', {
                        confirmButtonText: '签署',
                        cancelButtonText: '取消',
                        type: 'warning',
                        beforeClose: (action, instance, done) => {
                            if (action === 'confirm') {
                                instance.confirmButtonLoading = true;
                                instance.confirmButtonText = '执行中...';
                                check_and_control({case_ids:this.ids}).then(res=>{
                                    if (res.code==200){
                                        this.$message.success(res.msg)
                                        instance.confirmButtonLoading = false;
                                        done();
                                    }else {
                                        this.$message.error(res.msg)
                                        instance.confirmButtonLoading = false;
                                        done();
                                    }
                                })


                            }else {
                                done();
                            }
                        }
                    }).then(() => {

                    }).catch(() => {

                    });
                }
            },
            //批量提交至保险端
            submitBtn(){
                if (this.ids==undefined||this.ids==''){
                    this.$message.error('请选择案件');
                    return
                }else {
                    this.$confirm('请确认是否批量提交案件至保险端 ', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        submit_to({case_ids:this.ids}).then(res=>{
                            if (res.code==200){
                                this.$message.success(res.msg)
                                this.reload()
                            }else {
                                this.$message.error(res.msg)
                            }
                        })
                    }).catch(() => {

                    });
                }
            },
            //查看留言
            viewBtn(row){
                this.$router.push({path:'/leaveMessage',query:{id:row.id}})
            },
            //待确认保单保函
            verifyBtn(row){
                this.$router.push({path:'/insurancePolicy',query:{id:row.id}})
            },
            //再次上传投保材料到保险端
            resubmitBtn(row){
                this.$confirm('请确认是否再次上传投保材料到保险端 ', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    resubmitMaterial({case_id:row.id}).then(res=>{
                        if (res.code==200){
                            this.$message.success(res.msg)
                            this.reload()
                        }else {
                            this.$message.error(res.msg)
                        }
                    })
                }).catch(() => {

                });
            },
            //查看投保单
            viewInsureBtn(row){
                this.$router.push({path:'/viewInsurePage',query:{id:row.id}})
            },
            //上传已盖章投保单
            sealedInsureBtn(row){
                this.$router.push({path:'/uploadSealedInsure',query:{id:row.id}})
            },
            //查看保险收费信息
            viewChargeBtn(row){
                this.$router.push({path:'/chargeDetail',query:{id:row.id}})
            },
            //上传缴费信息
            paymentBtn(row){
                this.$router.push({path:'/uploadPayment',query:{id:row.id}})
            },
            //查看全部材料和文书
            allMaterialsBtn(row){
                this.$router.push({path:'/allMaterialsPage',query:{id:row.id}})
            }
        },
        created() {
            let insurePageSearch=sessionStorage.getItem('insurePageSearch')
            if (insurePageSearch){
                let insureParams=JSON.parse(sessionStorage.getItem("insurePageParams"));
                this.search=insureParams
                insureList(10,1,insureParams.jd_type_id,insureParams.zhcai_sn,insureParams.doc_title,insureParams.lawyer_name,insureParams.signers_txt).then(res=>{
                    if (res.code==200){
                        this.data=res.data.list
                        this.page.total=res.data.count
                        this.page.currentPage=insurePageSearch
                    }
                })
            }else {
                let insurePage=Number(sessionStorage.getItem('insurePage'))
                if (insurePage==0){
                    insureList(10,1).then(res=>{
                        if (res.code==200){
                            this.data=res.data.list
                            this.page.total=res.data.count
                            this.page.currentPage=1
                        }
                    })
                }else {
                    insureList(10,insurePage).then(res=>{
                        if (res.code==200){
                            this.data=res.data.list
                            this.page.total=res.data.count
                            this.page.currentPage=insurePage
                        }
                    })
                }
            }
        }
    };
</script>

<style scoped>
    .insureBox{
        padding: 20px;
        background-color: #ffffff;
        border-radius: 5px;
    }
    .el-dropdown-link {
        cursor: pointer;
        color: #409EFF;
    }
    .el-icon-arrow-down {
        font-size: 12px;
    }
    .pull-down{
        padding: 5px 30px !important;
    }
    /deep/.no-print{
        width: 200px;
    }
    .custom{
        background-color: #3e62f6;
        color: #ffffff;
    }
    .textStyle{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        cursor: default;
        margin:0;
    }
</style>
